import { BaseResponse } from '../../../../../../../types/api/api.types';
import { CONSULTATIONS_ENDPOINTS } from '../../../../../../../utils/api/endpoints/consultationsEndpoints';
import { DuplicateConsultationQuery } from './DuplicateConsultationModal.types';

const PREFIX = '[duplicateConsultationQuery]';

export const DUPLICATE_CONSULTATION_QUERY_KEY = 'DUPLICATE_CONSULTATION';

export const duplicateConsultationQuery = async ({
  consultationId,
}: DuplicateConsultationQuery) => {
  console.log(PREFIX, `Requesting duplicate consultation...`);

  const response = await CONSULTATIONS_ENDPOINTS.duplicate(consultationId);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received duplicate consultation.`);
  return json as BaseResponse & { consultationId: number };
};
